/**
 * BIAS — Fechamento menos MA.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLMomentum.cs, classe
 * FML.BIAS). Painel próprio, 3 linhas:
 *
 *   BIAS1 = (C − MA(C,L1)) / MA(C,L1) * 100
 *   BIAS2 = (C − MA(C,L2)) / MA(C,L2) * 100
 *   BIAS3 = (C − MA(C,L3)) / MA(C,L3) * 100
 *
 * Distância percentual entre o fechamento e três médias aritméticas.
 * Paridade provada em __tests__/bias.silverlight.test.js.
 */
import { ma, sub, div, mul } from "./silverlightDsl";
import { BIAS as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { l1, l2, l3 } = options;
    const close = data.map((d) =>
      Number.isFinite(d.close) ? d.close : Number.NaN,
    );

    const biasOf = (n) => {
      const m = ma(close, n);
      return mul(div(sub(close, m), m), 100);
    };

    const b1 = biasOf(l1);
    const b2 = biasOf(l2);
    const b3 = biasOf(l3);

    return b1.map((v, i) => {
      const o1 = Number.isFinite(v) ? v : undefined;
      const o2 = Number.isFinite(b2[i]) ? b2[i] : undefined;
      const o3 = Number.isFinite(b3[i]) ? b3[i] : undefined;
      if (o1 === undefined && o2 === undefined && o3 === undefined)
        return undefined;
      return { bias1: o1, bias2: o2, bias3: o3 };
    });
  }

  calculator.undefinedLength = function () {
    const { l1, l2, l3 } = options;
    return Math.max(0, Math.min(l1, l2, l3) - 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
